/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_Getting_TranslationsInputs */

const en_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error getting translations: ${i?.error}`)
};

const fr_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de la récupération des traductions : ${i?.error}`)
};

const de_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Abrufen der Übersetzungen: ${i?.error}`)
};

const it_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante il recupero delle traduzioni: ${i?.error}`)
};

const ru_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при получении переводов: ${i?.error}`)
};

const es_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al obtener las traducciones: ${i?.error}`)
};

const zh_cn2_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`获取翻译时出错：${i?.error}`)
};

const ja_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`翻訳の取得中にエラーが発生しました: ${i?.error}`)
};

const hi_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अनुवाद प्राप्त करने में त्रुटि: ${i?.error}`)
};

const pt_pt2_error_getting_translations = /** @type {(inputs: Error_Getting_TranslationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao obter traduções: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error getting translations: {error}" |
*
* @param {Error_Getting_TranslationsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_getting_translations = /** @type {((inputs: Error_Getting_TranslationsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Getting_TranslationsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_getting_translations(inputs)
	if (locale === "de") return de_error_getting_translations(inputs)
	if (locale === "it") return it_error_getting_translations(inputs)
	if (locale === "ru") return ru_error_getting_translations(inputs)
	if (locale === "es") return es_error_getting_translations(inputs)
	if (locale === "zh-CN") return zh_cn2_error_getting_translations(inputs)
	if (locale === "ja") return ja_error_getting_translations(inputs)
	if (locale === "hi") return hi_error_getting_translations(inputs)
	if (locale === "pt-PT") return pt_pt2_error_getting_translations(inputs)
	return en_error_getting_translations(inputs)
});